
import {QuoteEntryRequestModel} from './quote-entry-request-model';
export class SubmitQuoteModel {
    buyerID: string = null;
    quoteEntryRequest = new QuoteEntryRequestModel ();
    quoteTemplate: any = null;
    remark: string = null ;
    validity: string = null;
}
